<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmPermission"
      :title="this.$lang.Permission.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtName"><small class="text-danger">*</small> {{$lang.Permission.LabelTypePermission}}:</label>
          <div class="input-group">
            <v-select v-model="form.tipo.value" class="w-100 mb-3" label="text" @input="onChangePermissionType" :reduce="t => t.value" :clearable="false" :options="form.tipo.options">
            </v-select>
          </div>
        </div>
        <div class="col-md-6" v-show="permissionTypeGroup">
          <label for="txtGroup"><small class="text-danger">*</small> {{$lang.Permission.LabelGroups}}:</label>
          <div class="input-group">
            <v-select v-model="form.grupoID.value" label="text" :options="form.grupoID.options" :reduce="g => g.value" class="w-100 mb-3" @input="onChangeGroup">
            </v-select>
          </div>
        </div>
        <div class="col-md-6" v-show="permissionTypeUser">
          <label for="txtAccount"><small class="text-danger">*</small> {{$lang.Permission.LabelAccounts}}:</label>
          <div class="input-group">
            <v-select v-model="form.contaID.value" :options="form.contaID.options" :reduce="u => u.value" label="text" class="w-100 mb-3" @input="onChangeAccount">
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row hidden">
        <div class="col-md-12 pt-1">
          <h5 class="text-third"><i class="fa fa-shield"></i> {{$lang.Permission.Profile}}</h5>
        </div>
      </div>
      <div class="form-group row" style="height: calc(100vh - 425px);">
        <div class="col-md-5">
          <label for="txtName">{{$lang.Permission.LabelAvailable}}:</label>
          <div class="input-group" style="height: 95%;">
            <b-form-select v-model="form.permissoesDisponiveis.value" multiple :select-size="15" class="mb-3" >
              <b-form-select-option :id="'ava-' + idx" v-for="(option, idx) in form.permissoesDisponiveis.options" :key="idx" :value="option.value" style="width: max-content;">
                {{ option.text }}
                <b-popover custom-class="popover-details" variant="secondary" :target="'ava-' + idx" triggers="hover" v-if="availableProfile(option.value) && availableProfile(option.value).detalhes" :boundary="$refs.frmPermission" placement="right">
                  <div v-html="availableProfile(option.value).detalhes" style="width: 380px;"></div>
                </b-popover>
              </b-form-select-option>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2 text-center">
          <div class="d-none d-md-block">
            <b-button-group style="padding-top: 150px;">
              <button type="button" class="btn btn-default btn text-secondary" @click="onRemovePermissions"><i class="fa fa-arrow-circle-left"></i></button>
              <button type="button" class="btn btn-third btn text-default" @click="onAddPermissions"><i class="fa fa-arrow-circle-right"></i></button>
            </b-button-group>
          </div>
          <div class="d-block d-md-none">
            <b-button-group>
              <button type="button" class="btn btn-default btn text-secondary" @click="onRemovePermissions"><i class="fa fa-arrow-circle-up"></i></button>
              <button type="button" class="btn btn-third btn text-default" @click="onAddPermissions"><i class="fa fa-arrow-circle-down"></i></button>
            </b-button-group>
          </div>
        </div>
        <div class="col-md-5">
          <label for="txtName">{{$lang.Permission.LabelUsed}}:</label>
          <div class="input-group" style="height: 95%;">
            <b-form-select  v-model="form.permissoesUsadas.value" multiple :select-size="15" class="mb-3">
              <b-form-select-option :id="'sel-' + idx" v-for="(option, idx) in form.permissoesUsadas.options" :key="idx" :value="option.value" style="width: max-content;">
                {{ option.text }}
                <b-popover custom-class="popover-details" variant="secondary" :target="'sel-' + idx" triggers="hover" v-if="availableProfile(option.value) && selectedProfile(option.value).detalhes" :boundary="$refs.frmPermission" placement="left">
                  <div v-html="selectedProfile(option.value).detalhes" style="width: 380px;"></div>
                </b-popover>
              </b-form-select-option>
            </b-form-select>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import Permission from './permission.js'

export default Permission
</script>

<style>
  div.popover-details.popover {
    max-width: 400px;
    max-height: 40vh;
  }

  div.popover-details div.popover-body {
    max-width: 400px;
    max-height: 40vh;
  }

  div.popover-details.popover p {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/access/permission/permission.vue